import { render, staticRenderFns } from "./AddPersonByEmail.vue?vue&type=template&id=be6458e0&"
import script from "./AddPersonByEmail.vue?vue&type=script&lang=js&"
export * from "./AddPersonByEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports